import React, { useRef } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  ChartOptions,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import styled from 'styled-components';
import { useGoalPlanner } from 'app/Provider/GoalPlannerProvider';

ChartJS.register(ArcElement, Tooltip, Legend, Title);
/////////******Add default values to chart */
interface Prop {
  width: number;
  height: number;
  values: any;
  contribution?: string[];
}
export const InvestmentPieChart = (props: Prop) => {
  const { setMonthly } = useGoalPlanner();
  const chartRef = useRef(null);
  const calculatemonthlySavings = (FV, PV = 0, r, n, t): number => {
    if (r === 0 && t !== 0) {
      return FV / (12 * t);
    }
    if (t === 0) {
      return 0;
    }
    const monthlyContribution =
      (FV - PV * Math.pow(1 + r / n, n * t)) /
      ((Math.pow(1 + r / n, n * t) - 1) / (r / n));

    return monthlyContribution;
  };

  const monthlyContribution = calculatemonthlySavings(
    props.values.amount,
    0,
    props.values.returns / 100,
    12,
    props.values.years,
  );

  const hasZeroValue =
    props.values.amount === 0 ||
    props.values.years === 0 ||
    props.values.returns === 0;
  setMonthly(monthlyContribution.toFixed(2));
  const Data = {
    labels: hasZeroValue
      ? ['Investment Amount']
      : ['Invested Amount', 'Est. Returns'],
    datasets: [
      {
        label: 'Investment Details',
        data: hasZeroValue
          ? [1]
          : [
              monthlyContribution * props.values.years * 12,
              props.values.amount -
                monthlyContribution * props.values.years * 12,
            ],
        backgroundColor: hasZeroValue ? ' #C8CCD8' : [' #C6C0FA', ' #5C54AD'],
        borderWidth: 1,
      },
    ],
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    plugins: {
      title: {
        display: false,
        text: 'The total value of your investment after 6 Years will be ₹5,33,015',
      },
      legend: {
        display: false,
        labels: {
          usePointStyle: true,
          pointStyle: 'rect',
          padding: 20,
          font: {
            size: 14,
          },
        },
      },
    },
  };
  return (
    // <div className="d-flex flex-column justify-content-between w-100">
    //   <div>
    <div
      className="position-relative d-flex justify-content-between align-items-center"
      style={{
        width: '100%',
        height: props.height,
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
    >
      <div style={{ width: hasZeroValue ? '100%' : '60%', height: '217px' }}>
        <Doughnut ref={chartRef} options={options} data={Data} />
      </div>
      <div
        className="position-absolute top-50 end-30 translate-middle-y d-flex flex-column gap-4"
        style={{ right: '0px' }}
      >
        {!hasZeroValue &&
          Data.labels?.map((label, index) => (
            <div key={label} className="d-flex align-items-center gap-3">
              <div
                style={{
                  width: '5px',
                  height: '62px',
                  backgroundColor: Data.datasets[0].backgroundColor[index],
                  borderRadius: '20px',
                }}
              />
              <div className="d-flex flex-column justify-content-start">
                <span className="small fw-medium">{label}</span>
                <ValueText className="small fw-medium">
                  {'₹' + Data.datasets[0].data[index].toFixed(2)}
                </ValueText>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
const ValueText = styled.h6`
  //styleName: heading/h4_med;
  font-family: var(--fontfamilyactivefont);
  font-size: 28px;
  font-weight: 500;
  line-height: 38.19px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
`;
